import { HotSellerPeriodType } from "../../Types";

export type HotSellerState = {
    selectedPeriod: HotSellerPeriodType;
    isOpen: boolean;
    selectedFromDate: Date | null;
    selectedToDate: Date | null;
};

export type HotSellerAction =
    | { type: 'SET_PERIOD'; payload: HotSellerPeriodType }
    | { type: 'TOGGLE_DROPDOWN' }
    | { type: 'CLOSE_DROPDOWN' }
    | { type: 'SET_FROM_DATE'; payload: Date | null }
    | { type: 'SET_TO_DATE'; payload: Date | null };

export const hotSellerReducer = (state: HotSellerState, action: HotSellerAction): HotSellerState => {
    switch (action.type) {
        case 'SET_PERIOD':
            return {
                ...state,
                selectedPeriod: action.payload,
                selectedFromDate: action.payload !== 'Custom Date' ? null : state.selectedFromDate,
                selectedToDate: action.payload !== 'Custom Date' ? null : state.selectedToDate
            };
        case 'TOGGLE_DROPDOWN':
            return { ...state, isOpen: !state.isOpen };
        case 'CLOSE_DROPDOWN':
            return { ...state, isOpen: false };
        case 'SET_FROM_DATE':
            return { ...state, selectedFromDate: action.payload };
        case 'SET_TO_DATE':
            return { ...state, selectedToDate: action.payload };
        default:
            return state;
    }
};